import { getTranslation } from '@easy-expense/intl-client';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import { Image } from 'react-native';

export const BankLink: React.FC = () => {
  return (
    <Layout.Column grow align>
      <Spacer.Vertical size={24} />
      <OpenSans.Primary size={24} weight="bold-700" center>
        {getTranslation('Connect your Accounts')}
      </OpenSans.Primary>
      <Spacer.Vertical size={4} />
      <OpenSans.Secondary size="s-16" center>
        {getTranslation('Automate your bookkeeping and find tax deductions')}
      </OpenSans.Secondary>
      <Spacer.Vertical size={8} />

      <Spacer.Vertical size={24} />

      <Layout.Column grow style={{ width: '100%' }}>
        <Image
          source={require('../../../assets/BankLinkImage.png')}
          style={{ width: '100%', height: '100%', resizeMode: 'contain' }}
        />
      </Layout.Column>
      <Spacer.Vertical size={32} />
    </Layout.Column>
  );
};
